<template>
<b-overlay :show="show" rounded="sm">
  <b-container fluid class="bg-white">
    <b-row><b-col>&nbsp;</b-col></b-row>
    <b-row class="mb-3">
      <b-col>
        <h3 tabindex="0">{{acao === 'visualizar' ? 'Visualizar Configuração da Conferência' : 'Configurar Conferência'}}</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="2">&nbsp;</b-col>
      <b-col sm="8">
        <b-row>
          <b-col sm="_">
            <b-row align-h="end">
              <b-button pill variant="success">1</b-button>
            </b-row>
          </b-col>
          <b-col><hr/></b-col>
          <b-col sm="_">
            <b-row align-h="center">
              <b-button pill variant="success">2</b-button>
            </b-row>
          </b-col>
          <b-col><hr/></b-col>
          <b-col sm="_">
            <b-row align-h="start">
              <b-button pill variant="success">3</b-button>
            </b-row>
          </b-col>
          <b-col><hr/></b-col>
          <b-col sm="_">
            <b-row align-h="start">
              <b-button pill variant="primary">4</b-button>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mb-4">
      <b-col sm="12">
        <b-row>
          <b-col tabindex="0" sm="3">
            <b-row align-h="around">Dados da Conferência</b-row>
          </b-col>
          <b-col tabindex="0" sm="3">
            <b-row align-h="around">Datas da Conferência</b-row>
          </b-col>
          <b-col tabindex="0" sm="3">
            <b-row align-h="around">Pós-Conferência</b-row>
          </b-col>
          <b-col tabindex="0" sm="2">
            <b-row align-h="center">Texto Apresentação</b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-form @submit.stop.prevent="salvar">
      <b-row class="mb-2">  
      </b-row>
       <b-row>
        <b-col cols="12">
          <b-form-group tabindex="0" label="Texto de Apresentação: ">
            <vue-editor v-model="texto_apresentacao"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6">
          <b-row no-gutters>
            <b-button @click="voltar">
              <i class="fa fa-arrow-left"/>&nbsp;&nbsp;Voltar
            </b-button>
          </b-row>
        </b-col>
        <b-col sm="6">
          <b-row no-gutters align-h="end">
            <b-button type="submit" variant="primary">
              <i class="fa fa-floppy-o"/>&nbsp;&nbsp;{{acao === 'visualizar' ? 'Fechar' : 'Salvar e Fechar'}}
            </b-button>
          </b-row>
        </b-col>
      </b-row>
    </b-form>
    <b-row><b-col>&nbsp;</b-col></b-row>
  </b-container>
</b-overlay>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import SessionStorage from '@/services/session-storage'
import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor
  },
  data () {
    return {
      show: false,
      acao: this.$route.params.acao,
      texto_apresentacao: SessionStorage.get('texto_apresentacao') == 'null' ? '' : SessionStorage.get('texto_apresentacao')
    }
  },
  computed: {
    ...mapState({
      usuario: state => state.usuario.usuario,
      configurarConferencia: state => state.conferencia.configurarConferencia,
      mensagemConferencia: state => state.conferencia.mensagem
    })
  },
  mounted () {
    this.$store.dispatch('setConferencia', {
      'conferencia_id': SessionStorage.get('conferencia_atual_id'),
      'conferencia_nome': SessionStorage.get('conferencia_atual_nome')
    })

    Vue.http.post('api/configurarConferencia/buscar', {conferencia_id: this.configurarConferencia.conferencia_id}).then(response => {
      if (response.body.success && response.body.data.length > 0) {
        this.$store.dispatch('setConfigurarConferencia', response.body.data[0])
      }
    })

    if (this.mensagemConferencia) {
      this.sucesso(this.mensagemConferencia)
      this.$store.commit('setMensagemConferencia', null)
    }
  },
  methods: {
    navigate (route) {
      this.$router.push(route)
    },
    sucesso (mensagem) {
      this.$bvToast.toast(mensagem, {
        title: 'Sucesso',
        autoHideDelay: 10000,
        appendToast: true,
        variant: 'info'
      })
    },
    erro (mensagem) {
      this.$bvToast.toast(mensagem, {
        title: 'Erro',
        autoHideDelay: 10000,
        appendToast: true,
        variant: 'danger'
      })
    },
    voltar () {
      if (!this.configurarConferencia.situacao || this.configurarConferencia.situacao !== 'Finalizada' || this.acao === 'visualizar') {
        this.navigate('/configurarConferencia/passo3/' + this.acao)
      }
    },
    salvar () {
      if (this.acao === 'visualizar') {
        this.navigate('/configurarConferencia/gerenciar')
      } else {
        this.$bvModal.msgBoxConfirm('Tem certeza que deseja salvar a configuração dessa Conferência?', {
          noCloseOnBackdrop: true,
          centered: true,
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        }).then(valor => {
          this.show = true
          if (valor) {
            let dados = {
              id: this.configurarConferencia.conferencia_id,
              texto_apresentacao: this.texto_apresentacao,
            }

            Vue.http.post('api/conferencia/atualizarTextoApresentacao', dados).then(response => {
              if (response.body.success) {
                if (this.$route.params.acao === 'editar') {
                  this.$store.commit('setMensagemConferencia', 'Configuração da Conferência atualizada com sucesso!')
                  SessionStorage.set('texto_apresentacao', this.texto_apresentacao)
                  this.navigate('/configurarConferencia/gerenciar')
                } else {
                  this.$store.commit('setMensagemConferencia', 'Configuração da Conferência salva com sucesso!')
                  this.navigate('/')
                }
                this.show = false
              }
            })
          }
        })
      }
    }
  }
}
</script>

<style>
  .centro {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/conferencia/Passo4.vue